import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const isAsyncTagsWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  filterItem.key === 'tag' &&
  !!filterItem.config.is_values_required &&
  !filterItem.config.values.length
